module.exports = __webpack_public_path__ + "static/media/disableFullScreen-dark.a79b8779.svg";